import script from "./EmojiSelectorTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmojiSelectorTabs.vue?vue&type=script&lang=ts&setup=true"

import "./EmojiSelectorTabs.vue?vue&type=style&index=0&id=19044c39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19044c39"]])

export default __exports__